import { GRADIENT_MODES } from "@/constants/gradientModes";
import { withUnits } from "@/utils/stringHelpers";

export const GradientType = {
  DegradationLevel: GRADIENT_MODES.DEGRADATION_LEVEL,
  Material: GRADIENT_MODES.MATERIAL,
  JointType: GRADIENT_MODES.JOINT_TYPE,
  AngleVerical: GRADIENT_MODES.ANGLE_VERTICAL,
  AngleHorizontal: GRADIENT_MODES.ANGLE_HORIZONTAL,
  GapWidthMean: GRADIENT_MODES.GAP_WIDTH_MEAN,
  GapWidthMax: GRADIENT_MODES.GAP_WIDTH_MAX,
};

export const GRADIENT_TYPES_DISPLAY_DECORATORS = {
  [GradientType.GapWidthMean]: (value) => withUnits(value, "mm"),
  [GradientType.GapWidthMax]: (value) => withUnits(value, "mm"),
};

export const GRADIENT_TYPES_DICTIONARY_KEY = "joints.details.map_select";
